module.exports = __webpack_public_path__ + "static/media/filterFunel.98134693.png";